import React, { useState } from 'react';
import Pagination from './Pagination';
import Toast from './Toast';

export default function Media() {
  const [toast, setToast] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const showToast = (msg) => {
    setToast({ message: msg, type: 'default' });
    setTimeout(() => setToast(null), 3000);
  };

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Media library <em>· assets</em></h1>
          <div className="admin-page__sub">
            <span><strong>342</strong> assets</span>
            <span><strong>2.18 GB</strong> (7% of quota)</span>
            <span>CDN region: Sydney</span>
          </div>
        </div>
        <div className="admin-page__actions">
          <button className="btn-ghost" onClick={() => showToast('Bulk tagging initiated')}>Bulk tag</button>
          <button className="btn-ghost" onClick={() => showToast('Sync initiated')}>Sync from Figma</button>
          <button className="btn-primary" onClick={() => showToast('Upload modal opened')}>+ Upload</button>
        </div>
      </div>

      <div className="admin-toolbar">
        <div className="admin-tabs">
          {['All', 'Images', 'Logos', 'Video', 'Documents'].map((tab, idx) => (
            <div key={idx} className={`admin-tab ${idx === 0 ? 'is-active' : ''}`}>{tab}</div>
          ))}
        </div>
        <div className="admin-filters">
          <select className="filter-select"><option>Sort — Recently uploaded</option></select>
          <button style={{ padding: '6px 12px', border: '1px solid rgba(244,241,234,0.08)', background: 'transparent', color: 'var(--graphite-2)', cursor: 'pointer', fontSize: '12px' }}>Grid</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '12px', marginTop: '32px' }}>
        {Array(32).fill(null).map((_, idx) => (
          <div key={idx} style={{ border: '1px solid rgba(244,241,234,0.08)', borderRadius: '2px', overflow: 'hidden', cursor: 'pointer' }}>
            <div style={{ height: '100px', backgroundColor: 'rgba(244,241,234,0.05)', backgroundImage: 'repeating-linear-gradient(45deg,rgba(244,241,234,0.1) 0,rgba(244,241,234,0.1) 2px,transparent 2px,transparent 8px)', position: 'relative' }}>
              <div style={{ fontSize: '10px', padding: '4px 6px', backgroundColor: 'var(--ink)', border: '1px solid rgba(244,241,234,0.2)', position: 'absolute', top: '4px', right: '4px', borderRadius: '2px' }}>PNG</div>
            </div>
            <div style={{ padding: '8px', fontSize: '11px', color: 'var(--graphite-2)' }}>image_{idx + 1}.png</div>
          </div>
        ))}
      </div>

      <Pagination currentPage={currentPage} totalItems={342} itemsPerPage={32} onPageChange={setCurrentPage} />

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
}
